import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import ErrorOutline from '@mui/icons-material/ErrorOutline';
import Refresh from '@mui/icons-material/Refresh';
import { t } from 'i18next';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught in ErrorBoundary:", error, errorInfo);
    this.setState({ hasError: true });
  }

  handleRetry = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            padding: "24px",
            backgroundColor: "#f8f9fa",
          }}
        >
          <Box
            sx={{
              textAlign: "center",
              maxWidth: "400px",
              width: "100%",
              padding: "40px 24px",
              borderRadius: "16px",
              backgroundColor: "#fff",
              boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
            }}
          >
            <ErrorOutline
              sx={{
                fontSize: 56,
                color: "#ff4b4b",
                mb: 2,
                opacity: 0.8,
              }}
            />
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: "#1a1a2e",
                mb: 1,
              }}
            >
              {t("Oops! Something went wrong.")}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "#667085",
                mb: 3,
                lineHeight: 1.6,
              }}
            >
              {t("It looks like something didn't work as expected. Please try again later or contact support if the issue persists.")}
            </Typography>
            <Button
              variant="contained"
              startIcon={<Refresh />}
              onClick={this.handleRetry}
              sx={{
                backgroundColor: "#6ba5f2",
                borderRadius: "10px",
                padding: "10px 28px",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "14px",
                boxShadow: "0 2px 8px rgba(107,165,242,0.3)",
                "&:hover": {
                  backgroundColor: "#5a94e0",
                },
              }}
            >
              {t("Try Again")}
            </Button>
          </Box>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
